import { serialize } from 'object-to-formdata'
import { ref, toValue } from 'vue'
import config from '@/config/api'
import { useStorage } from '@/composables/storage'
import { useNotify } from '@/composables/notify'
import { isArray } from 'lodash'

export async function useApi(auth, method, model, params = null, keys = null,redirectOn403 = true) {
    const result = ref(null)
    const data = ref(null)
    const status = ref(null)
    const ok = ref(null)
    const errors = ref(null)
    const message = ref(null)

    if (!isArray(keys)) {
        keys = [keys]
    }

    if (!params) {
        params = {}
    }

    const notify = useNotify()
    const token = getToken(auth)
    checkAuth()
    let requestUrl = getUrl()
    const response = await fetch(requestUrl, getOptions())

    status.value = response.status
    ok.value = response.ok
    result.value = await getResponseResult(response)

/**
    console.log(requestUrl)
    console.log(getOptions())
    console.log(response.ok)
    console.log(result.value)
**/

    if (result.value?.data) {
        data.value = result.value.data
    }
    if (result.value?.errors) {
        errors.value = result.value.errors
    }
    if (result.value?.message) {
        message.value = result.value.message
    }
    if (response.status == 401) {
        loginRedirect()
    } else if (response.status == 403) {
        if (redirectOn403) {
            loginRedirect()
        }
    }
    if (response.status == 429) {
        notify.error('form.error_429')
    }

    async function getResponseResult(response) {
        const contentType = response.headers.get('Content-Type')
        if (contentType && contentType.includes('application/json')) {
            return await response.json()
        } else if (contentType && contentType.includes('text/')) {
            return await response.text()
        } else if (contentType && (contentType.includes('application/') || contentType.includes('image/'))) {
            return await response.blob()
        } else {
            console.log('Unknown response type:', contentType)
            return null
        }
    }

    function getToken() {
        let token = null
        if (auth) {
            const { get } = useStorage()
            token = get('token')
        }
        return token
    }

    function checkAuth() {
        if (auth && token == null) {
            loginRedirect()
        }
    }

    function loginRedirect() {
        const url = new URL(window.location)
        if (url.pathname !== '/login') {
            window.location.href = '/login'
        }
    }

    function getOptions() {
        let options = {}
        let body = null;
        const headers = getHeaders();

        // --- ИСПРАВЛЕННЫЙ БЛОК ---
        if (['store', 'restore'].includes(method)) {
            body = getBody();
        } else if (method === 'update') {
            body = getBody({ _method: 'PUT' });
        } else if (method === 'destroy') {
            // ДОБАВЛЕНО: Говорим Laravel, что это DELETE-запрос
            body = getBody({ _method: 'DELETE' });
        } else if (method === 'post') {
            body = getBody();
        }
        // -------------------------

        if (body) {
            options.body = body;
            if (!(body instanceof FormData)) {
                headers.append('Content-Type', 'application/json;charset=utf-8');
                options.body = JSON.stringify(body);
            }
        }

        options.headers = headers;
        options.method = (['store', 'update', 'destroy', 'restore', 'post'].includes(method)) ? 'POST' : 'GET';

        return options;
    }

    function getHeaders() {
        const headers = new Headers({ Accept: 'application/json' })
        if (token !== null) {
            headers.append('Authorization', 'Bearer ' + token)
        }
        return headers
    }

    function getUrl() {
        let pathname = ''

        // --- НАЧАЛО ИЗМЕНЕНИЯ ---
        // Проверяем не просто на наличие, а на то, что это реальный ID (число или непустая строка)
        const firstKey = keys && keys.length > 0 ? keys[0] : null;
        if (firstKey && (typeof firstKey === 'number' || typeof firstKey === 'string')) {
            // --- КОНЕЦ ИЗМЕНЕНИЯ ---

            pathname = '/' + firstKey

            // Отдельно обрабатываем особый случай для 'restore'
            if (method === 'restore') {
                pathname += '/restore'
            }
        }

        let url = new URL(config.baseURL + model + pathname)
        url = addSearchParams(params, url)
        return url
    }

    function addSearchParams(params, url) {
        const isGetRequest = ['index', 'show'].find((item) => item === method)
        if (isGetRequest && params) {
            const paramsValue = toValue(params)
            for (const key in paramsValue) {
                if (!paramsValue[key]) continue
                let parameterValue = toValue(paramsValue[key])
                if (!parameterValue) continue
                parameterValue = parameterValue.value ?? parameterValue
                if (key === 'filters') {
                    for (const filterKey in parameterValue) {
                        if (parameterValue[filterKey]) {
                            const name = `filter[${filterKey}]`
                            const value = parameterValue[filterKey]
                            url.searchParams.append(name, value)
                        }
                    }
                } else {
                    url.searchParams.append(key, parameterValue)
                }
            }
        }
        return url
    }

    function getBody(additionalParams = {}) {
        if (params instanceof FormData) {
            if (additionalParams) {
                for (const key in additionalParams) {
                    params.append(key, additionalParams[key]);
                }
            }
            return params;
        }

        const resultParams = Object.assign({}, params, additionalParams)

        return serialize(resultParams, {
            indices: true,
            nullsAsEmptyString: true,
            booleansAsIntegers: true
        });
    }

    return { result, data, status, ok, errors, message, requestUrl }
}